import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const toastNotificationRootFn = /* @__PURE__ */ createRecipe('toast-notification-root', {}, [])

const toastNotificationRootVariantMap = {}

const toastNotificationRootVariantKeys = Object.keys(toastNotificationRootVariantMap)

export const toastNotificationRoot = /* @__PURE__ */ Object.assign(memo(toastNotificationRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'toastNotificationRoot',
  __getCompoundVariantCss__: toastNotificationRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: toastNotificationRootVariantKeys,
  variantMap: toastNotificationRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, toastNotificationRootVariantKeys)
  },
  getVariantProps: toastNotificationRootFn.getVariantProps,
})